import { View, Text, StyleSheet, Image, TouchableOpacity, TextInput, ActivityIndicator, FlatList, Modal, ScrollView } from 'react-native'
import React, { useEffect, useRef, useState } from 'react'
import TopHeaderComponent from '../aTopHeader/TopHeaderComponent'
import Colours from '../../utils/Colours'
import SearchIcon from '../../icons/SearchIcon'
import MoneyIcon from '../../icons/MoneyIcon'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'

const TablesToUseScreen = ({ hideScreen, pullsData, userName, doingsAmount, setDoingsAmount, supportDoings, transfarDoings }) => {

    const [tableDataList, setTableDataList] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [selectedTable, setSelectedTable] = useState(null)
    const [isButtonClicked, setIsButtonClicked] = useState(false)
    const [isButtonClickedd, setIsButtonClickedd] = useState(false)

    const axiosPrivate = useAxiosPrivate()

    const [isFormContainerClicked, setIsFormContainerClicked] = useState(false)

    const scrollViewRef = useRef(null)

    useEffect(() => {
        getTableData()
    }, [])



    const getTableData = async () => {
        //axios.get('/newTable').then((response) => {
        setIsLoading(true)
        await axiosPrivate.get('/newTable').then((response) => {
            //console.log('GETNEWTABLEREFRESH:', response.data.allTables)
            if (response.status === 200) {
                setTableDataList(response.data.allTables)
                setIsLoading(false)
            } else {
                //console.log("YOU HAVE NO TABLES")
                setIsLoading(false)
            }
        }).catch((error) => {
            //console.log('GetAllTableError:', error)
            setIsLoading(false)
        })
    }


    const handleProceedWithDoingsAmt = () => {
        if (doingsAmount === '') {
            setIsFormContainerClicked(true)
        } else {
            setIsButtonClicked(!isButtonClicked)
            hideScreen()
        }
    }
    const handleUseAll = (theTableValue) => {
        setDoingsAmount(theTableValue)
        setIsButtonClickedd(!isButtonClickedd)
        hideScreen()
    }

    const handleOnEnterAmount = (text) => {
        setDoingsAmount(text.toLocaleString())
        //console.log('text', text)
    }
    const handleTapToSelect = (selectedTable_id) => {
        setSelectedTable(tableDataList.find(tableData => tableData._id === selectedTable_id))
        // Scroll to the top when a table is selected
        if (scrollViewRef.current) {
            scrollViewRef.current.scrollTo({ y: 0, animated: true });
        }
    }

    return (
        <View>
            <TopHeaderComponent headerText={'My Tables'} hideScreen={hideScreen} />
            <ScrollView
                ref={scrollViewRef}
                style={styles.componentStyle}
                contentContainerStyle={{ flexGrow: 1, paddingBottom: 100 }}
                showsVerticalScrollIndicator={false}
            >

                {selectedTable ?
                    <>
                        <View style={styles.textboxAmountContainer2}>
                            <View style={styles.textboxHeader}>
                                <Text style={{ marginTop: 10, marginBottom: 10, fontSize: 15, color: Colours.DARKGRAY, fontFamily: 'Sen-Bold' }} >{selectedTable.tableCaption} </Text>
                            </View>

                            <View style={styles.tableAmountContainer}>
                                <MoneyIcon color={Colours.PRIMARY_LIGHT} />
                                <Text style={{ color: Colours.DARKGRAY, fontSize: 13, fontFamily: 'Sen-Regular' }}>Money on the Table:</Text>
                                <Text style={{ color: Colours.PRIMARY, fontSize: 16, fontFamily: 'Sen-Bold' }}>N{selectedTable.tableValue}</Text>
                            </View>
                            <TouchableOpacity style={[styles.buttonGray,
                            { backgroundColor: isButtonClickedd ? Colours.PRIMARY : Colours.LIGHTGRAY }]}
                                onPress={() => handleUseAll(selectedTable.tableValue)}>

                                <Text style={{ color: isButtonClickedd ? "white" : Colours.DARKGRAY, fontSize: 17, fontFamily: 'Sen-Bold' }}>Use all </Text>

                            </TouchableOpacity>
                        </View>

                        <View style={styles.textboxAmountContainer}>
                            <View style={styles.textboxHeader}>
                                <Text style={{ marginTop: 10, marginBottom: 10, fontSize: 15, color: Colours.DARKLIGHTGRAY, fontFamily: 'Sen-Bold' }} >Doings Amount </Text>
                                <Text style={{ paddingLeft: 1, paddingBottom: 0, color: Colours.PRIMARY_LIGHT, fontFamily: 'Sen-Regular' }}>|:</Text>
                            </View>

                            {pullsData ? (
                                <>
                                    <Text style={{ marginTop: 10, fontSize: 13, color: Colours.DARKLIGHTGRAY, fontFamily: 'Sen-Regular' }}>
                                        How much would you likely spend at
                                        <Text style={{ fontSize: 13, color: Colours.PRIMARY, fontFamily: 'Sen-Regular' }}> "{pullsData.pullCaption}"</Text>
                                    </Text>
                                </>
                            ) : userName && supportDoings ? (
                                <>
                                    <Text style={{ marginTop: 10, fontSize: 13, color: Colours.DARKLIGHTGRAY, fontFamily: 'Sen-Regular' }}>
                                        Amount will be sent to
                                        <Text style={{ fontSize: 13, color: Colours.PRIMARY, fontFamily: 'Sen-Regular' }}> {userName} </Text>as a "support" gift, courtesy of you.
                                    </Text>
                                </>
                            ) : userName ? (
                                <>
                                    <Text style={{ marginTop: 10, fontSize: 13, color: Colours.DARKLIGHTGRAY, fontFamily: 'Sen-Regular' }}>
                                        Amount will be sent to
                                        <Text style={{ fontSize: 13, color: Colours.PRIMARY, fontFamily: 'Sen-Regular' }}> {userName} </Text>as a gift, courtesy of you.
                                    </Text>
                                </>
                            ) : (
                                <Text style={{ marginTop: 10, fontSize: 13, color: Colours.DARKLIGHTGRAY, fontFamily: 'Sen-Regular' }}>

                                </Text>
                            )}


                            <View style={styles.textBoxContainer}>
                                <View style={styles.SearchBox}>
                                    <TextInput
                                        style={[styles.inputTxt, isFormContainerClicked && styles.focusedBorder,
                                            //{ borderColor: isFormContainerClicked ? Colours.PRIMARY : Colours.LIGHTGRAY },
                                        ]}
                                        placeholder="Enter Amount"
                                        keyboardType='numeric'
                                        onFocus={() => setIsFormContainerClicked(true)}
                                        onBlur={() => setIsFormContainerClicked(false)}
                                        value={doingsAmount}
                                        onChangeText={(text) => {
                                            const numericValue = Number(text.replace(/\D/g, ''))
                                            const formattedValue = numericValue.toLocaleString()
                                            handleOnEnterAmount(formattedValue)
                                        }}
                                    />

                                </View>
                                <View style={{ backgroundColor: Colours.DARKLIGHTGRAY, height: 30, width: 1, }}></View>
                                {/* <SearchIcon color={Colours.DARKGRAY} /> */}
                                <MoneyIcon color={Colours.PRIMARY} />
                            </View>
                            <TouchableOpacity style={[styles.buttonGray,
                            { backgroundColor: isButtonClicked ? Colours.PRIMARY : Colours.LIGHTGRAY }]}
                                onPress={() => handleProceedWithDoingsAmt()}>

                                <Text style={{ color: isButtonClicked ? "white" : Colours.DARKGRAY, fontSize: 17, fontFamily: 'Sen-Bold' }}>Proceed</Text>

                            </TouchableOpacity>
                        </View>
                    </>
                    : ""}

                {isLoading ? (<View style={{ justifyContent: 'center', alignItems: 'center' }}>
                    <ActivityIndicator size={'large'} color={Colours.PRIMARY} />
                </View>) : (
                    <FlatList
                        data={tableDataList}
                        scrollEnabled={false}
                        keyExtractor={(tables) => tables._id}
                        renderItem={({ item: table }) => (
                            <TouchableOpacity style={styles.textboxAmountContainer3}
                                onPress={() => handleTapToSelect(table._id)}
                            >
                                <View style={styles.textboxHeader}>
                                    <Text style={{ marginTop: 10, marginBottom: 10, fontSize: 15, color: Colours.DARKGRAY, fontFamily: 'Sen-Bold' }} >{table.tableCaption}</Text>
                                </View>

                                <View style={styles.tableAmountContainer}>
                                    <MoneyIcon color={Colours.PRIMARY_LIGHT} />
                                    <Text style={{ color: Colours.DARKGRAY, fontSize: 13, fontFamily: 'Sen-Regular' }}>Money on the Table:</Text>
                                    <Text style={{ color: Colours.PRIMARY, fontSize: 16, fontFamily: 'Sen-Bold' }}>N{table.tableValue}</Text>
                                </View>
                            </TouchableOpacity>)}
                    />)}

            </ScrollView>
        </View>
    )
}

const styles = StyleSheet.create({
    componentStyle: {
        backgroundColor: Colours.LIGHTEST,
        height: '100%',
        paddingTop: 20,

    },
    textboxAmountContainer: {
        margin: 15,
        marginTop: 15,
        marginBottom: 40,
        padding: 15,
        // width: 400,
        borderRadius: 15,
        //   height:200,
        backgroundColor: 'white',
        //   backgroundColor: '#E8E8E8',
        shadowColor: '#E8E8E8'
    },
    textboxAmountContainer2: {
        margin: 15,
        marginTop: 0,
        marginBottom: 0,
        padding: 15,
        paddingTop: 0,
        // width: 400,
        borderRadius: 15,
        //   height:200,
        backgroundColor: 'white',
        //   backgroundColor: '#E8E8E8',
        shadowColor: '#E8E8E8'
    },
    textboxAmountContainer3: {
        margin: 15,
        marginTop: 0,
        padding: 15,
        // width: 400,
        borderRadius: 15,
        //   height:200,
        backgroundColor: 'white',
        //   backgroundColor: '#E8E8E8',
        shadowColor: '#E8E8E8'
    },

    textboxHeader: {
        display: 'flex',
        flexDirection: 'row',
        //    justifyContent: 'center',
        alignItems: 'center',
        gap: 1,
    },
    textBoxContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 10,
        // backgroundColor:'blue',
    },
    focusedBorder: {
        borderColor: Colours.PRIMARY,
        borderWidth: 2
    },
    inputTxt: {
        height: 40,
        width: 250,
        marginTop: 10,
        // gap: 10,
        padding: 10,
        borderWidth: 2.5,
        borderColor: Colours.LIGHTGRAY,
        borderRadius: 7,
        fontFamily: 'Sen-Regular',
        fontSize: 15,
        backgroundColor: Colours.LIGHTGRAY,
        marginBottom: 10,
        marginRight: 10,
    },
    tableAmountContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 5,
        marginBottom: 10,
    },
    buttonGray: {
        display: 'flex',
        borderRadius: 10,
        justifyContent: 'center',
        marginTop: 10,
        alignItems: 'center',
        height: 55,
        width: '100%',
        backgroundColor: Colours.DARKGRAY,
    },
})

export default TablesToUseScreen

